import * as React from "react";
const SvgTag1 = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871V10.43l6.004 6.004 6.002 6.002 4.28-4.28 4.279-4.279-6.002-6.002-6.004-6.004H6.15ZM3.38 3.38H9.816l5.248 5.25 5.25 5.248-3.218 3.219-3.219 3.218-5.248-5.25-5.25-5.248V6.598Zm3.058 1.996-.53.531-.53.532.937.937.938.94.531-.532.531-.531-.939-.938Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgTag1;
